import { createContext, useContext } from "react";

export type ThemeModeType = "light" | "dark";

export type ThemeModeContextType = {
  theme: ThemeModeType
  systemPreferredTheme: ThemeModeType
  userPreferredTheme?: ThemeModeType | null,
  setUserPreferredTheme: (theme: ThemeModeType | null) => void
}

export const ThemeModeContext = createContext<ThemeModeContextType>({
  theme: "light",
  systemPreferredTheme: "light",
  setUserPreferredTheme: theme => {},
});

export const useThemeModeContext = () => useContext(ThemeModeContext);
